import { SwingWtPrefix, SwingWtSuffix } from '@/api/models';
import { sortByPropKey } from '@/utils';

interface ISwingWtOption {
  swingWeightId: number; // autonumber
  name: string; // concatenation of prefix+suffix
  swingWtPrefixId: number;
  swingWtPrefixName: string;
  swingWtSuffixId: number;
  swingWtSuffixName: string;
}

export interface ISwingWtOptionMap {
  map: Record<string, ISwingWtOption>;
  options: { id: string; label: string }[];
}

interface IBuildDropdownData {
  swingWtPrefix: SwingWtPrefix[];
  swingWtSuffix: SwingWtSuffix[];
}

export const buildDropdownData = ({ swingWtPrefix, swingWtSuffix }: IBuildDropdownData) => {
  let swingWeightId = 1;

  return swingWtPrefix.sort(sortByPropKey<SwingWtPrefix>('name')).reduce<ISwingWtOptionMap>(
    (acc, prefix) => {
      swingWtSuffix.forEach((suffix) => {
        const value = `${prefix.name}${suffix.name}`;

        const code: ISwingWtOption = {
          swingWeightId: swingWeightId++,
          name: value,
          swingWtPrefixId: prefix.swingWtPrefixId,
          swingWtPrefixName: prefix.name,
          swingWtSuffixId: suffix.swingWtSuffixId,
          swingWtSuffixName: suffix.name,
        };

        acc.map[value] = code;
        acc.options.push({ id: value, label: value });
      });
      return acc;
    },
    { map: {}, options: [] },
  );
};
